export default class QCTemplateParser {
    static parseData(dataFromAPI, templateDataToReturn) {
        templateDataToReturn = dataFromAPI
        return templateDataToReturn
    }
}
